import { Card, CardContent } from "@mui/material";

const ModernCard = ({
  children,
  elevation = 0,
  padding = 3,
  borderRadius = 4,
  gradient = false,
  glow = false,
  ...props
}) => {
  return (
    <Card
      elevation={elevation}
      sx={{
        borderRadius,
        padding: 0,
        background: gradient
          ? "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%)"
          : "rgba(255, 255, 255, 0.98)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        boxShadow: glow
          ? "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 20px rgba(102, 126, 234, 0.1)"
          : "0 20px 40px -12px rgba(0, 0, 0, 0.15)",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-6px) scale(1.01)",
          boxShadow: glow
            ? "0 32px 64px -12px rgba(0, 0, 0, 0.3), 0 0 40px rgba(102, 126, 234, 0.25)"
            : "0 28px 56px -12px rgba(0, 0, 0, 0.25)",
          borderColor: "rgba(102, 126, 234, 0.4)",
        },
        "&::before": gradient
          ? {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
              borderRadius: `${borderRadius * 8}px ${borderRadius * 8}px 0 0`,
            }
          : {},
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: gradient
            ? "radial-gradient(circle at top right, rgba(102, 126, 234, 0.05), transparent 50%)"
            : "radial-gradient(circle at top right, rgba(102, 126, 234, 0.03), transparent 50%)",
          pointerEvents: "none",
          opacity: 0,
          transition: "opacity 0.4s ease",
        },
        "&:hover::after": {
          opacity: 1,
        },
        ...props.sx,
      }}
      {...props}
    >
      <CardContent
        sx={{
          padding: `${padding * 8}px !important`,
          position: "relative",
          zIndex: 1,
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default ModernCard;
